//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import type { GetUserDisclaimerContentResponse } from './models/GetUserDisclaimerContentResponse';
import type { GetUserDisclaimerResponse } from './models/GetUserDisclaimerResponse';
import { Utilities } from './Utilities';
import type { ValidateUserDisclaimerRequest } from './models/ValidateUserDisclaimerRequest';

export class UserDisclaimersClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getUserDisclaimer: (
			application?: string,
        ): string => {
            let clientRequestUrl = '/api/v3/user-disclaimers?';
            if (application === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('application'));
            } else if (application !== undefined) {
                clientRequestUrl += `application=${encodeURIComponent(String(application))}&`;
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        validateUserDisclaimer: (): string => {
            let clientRequestUrl = '/api/v3/user-disclaimers';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getLastValidatedContent: (): string => {
            let clientRequestUrl = '/api/v3/user-disclaimers/last-validated-content';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        generateContent: (
			language?: string,
			application?: string,
        ): string => {
            let clientRequestUrl = '/api/v3/user-disclaimers/do-generate-content?';
            if (language === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('language'));
            } else if (language !== undefined) {
                clientRequestUrl += `language=${encodeURIComponent(String(language))}&`;
            }
            if (application === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('application'));
            } else if (application !== undefined) {
                clientRequestUrl += `application=${encodeURIComponent(String(application))}&`;
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    };

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Retrieves all disclaimer information related to the specified application and the connected user.
     * @param application (optional) The application key for which disclaimers are retrieved.
     * @return OK
     */
    async getUserDisclaimer(
        application?: string,
    ): Promise<GetUserDisclaimerResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getUserDisclaimer(
            application,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<GetUserDisclaimerResponse>(_response, false, []);
    }

    /**
     * Validates the disclaimer for the connected user and the specified application.
     * @param body (optional) The request containing the application information.
     * @return No Content
     */
    async validateUserDisclaimer(
        body?: ValidateUserDisclaimerRequest,
    ): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.validateUserDisclaimer();

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<void>(_response, false, []);
    }

    /**
     * Retrieves the last validated disclaimer content for the connected user.
     * @return OK
     */
    async getLastValidatedContent(): Promise<GetUserDisclaimerContentResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getLastValidatedContent();

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<GetUserDisclaimerContentResponse>(_response, false, []);
    }

    /**
     * Generates disclaimer content for the connected user based on the specified language and application.
     * @param language (optional) The language in which the disclaimer content should be generated.
     * @param application (optional) The application key for which the disclaimer content is generated.
     * @return OK
     */
    async generateContent(
        language?: string,
        application?: string,
    ): Promise<GetUserDisclaimerContentResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.generateContent(
            language,
            application,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<GetUserDisclaimerContentResponse>(_response, false, []);
    }
}
